// extracted by mini-css-extract-plugin
export default {"paginationContainer":"v8xvs"};